// react
import React from "react";

// components
import Icon from "../../../components/Icon";

import PropTypes from "../../../lib/prop-types";

// config
import Config from "../config";

export default class ErrorNotification extends React.Component {
	static propTypes = {
		style: PropTypes.object,
		message: PropTypes.string,
		undoCallback: PropTypes.func.isRequired,
	};

	static defaultProps = {
		style: {},
		message: "",
	};

	handleUndo = () => {
		this.props.undoCallback();
	};

	render() {
		const { message, style } = this.props;

		return (
			<section style={{ width: Config.get("width"), ...style }} className="notification-box type-undo">
				<div className="inner-wrapper">
					<div>
						<div className="message-icon">
							<Icon size={20} name="undo" type="material" />
						</div>

						<div className="message">{message}</div>

						<div className="button-container">
							<div onClick={this.handleUndo} className="undo-button">
								Undo
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}
